/**
 * avatars/presets/textures/index.js
 * Dispatcher tạo procedural canvas textures cho nhân vật voxel theo registry pattern.
 */

import { createCanvas } from '../../../core/canvas-texture.js';
import { generateFaceTexture } from './face.js';
import { generateTorsoTexture } from './torso.js';
import {
  generateHeadSideTexture,
  generateHeadBackTexture,
  generateArmBareTexture,
  generateBlobShadowTexture,
  generateAoDaiFlapTexture,
  generateTorsoBackTexture
} from './other-parts.js';

export { generateSpeciesSkinTexture } from './species-skin.js';
export { drawLotusFlower, drawLotusLeaf, drawStem, MOTIF_ASPECT } from './motifs.js';

const TEXTURE_GENERATORS = {
  face: generateFaceTexture,
  torso: generateTorsoTexture,
  head_side: generateHeadSideTexture,
  head_back: generateHeadBackTexture,
  arm_bare: generateArmBareTexture,
  blob_shadow: generateBlobShadowTexture,
  ao_dai_flap: generateAoDaiFlapTexture,
  torso_back: generateTorsoBackTexture
};

/**
 * Sinh texture Canvas độ nét cao cho các bộ phận nhân vật
 * @param {string} type - 'face' | 'torso' | 'head_side' | 'head_back' | 'arm_bare' | 'blob_shadow' | 'ao_dai_flap' | 'torso_back'
 * @param {object} [options={}] - Cấu hình màu sắc, biểu cảm, phụ kiện
 * @returns {HTMLCanvasElement}
 */
export function generateProceduralTexture(type, options = {}) {
  const size = options.size || 256;
  const canvas = createCanvas(size, size);
  const ctx = canvas.getContext('2d');

  const generator = TEXTURE_GENERATORS[type];
  if (generator) {
    generator(ctx, size, options);
  }

  return canvas;
}
